module.exports = __webpack_public_path__ + "img/flame_disabled_icon.14253d5b.svg";